var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11.042 8.979"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.023 8.03.493 4.5l1.06-1.06 2.47 2.47L9.493.44l1.06 1.06z"
})));
export default SvgCheckMark;